<template>
  <div class="unlock-download" ref="overlay" data-animate="unlock-download">
    <div
      class="unlock-download__background"
      @click.self="close"
      data-animate="unlock-download-background"
    />
    <div
      class="unlock-download__content"
      data-animate="unlock-download-content"
    >
      <div class="unlock-download__content__form">
        <FormKit
          v-if="showForm"
          v-model="userData"
          type="form"
          :actions="false"
          @submit="onSubmit"
          id="downloadForm"
        >
          <!-- Name -->
          <FormKit
            type="text"
            name="fullName"
            :label="$t('form.fullNameLabel')"
            validation="required"
            :placeholder="$t('form.fullName')"
          />
          <!-- Role -->
          <FormKit
            type="select"
            select-icon="down"
            :placeholder="$t('form.role')"
            :label="$t('form.roleLabel')"
            name="role"
            validation="required"
            :options="$t('form.roles').split(',')"
          />

          <!-- Email -->
          <FormKit
            type="email"
            name="email"
            :label="$t('form.emailLabel')"
            validation="required|email"
            :placeholder="$t('form.email')"
          />
          <!-- CHECKBOX -->
          <FormKit
            type="checkbox"
            name="terms"
            validation="accepted"
            :validation-messages="{ accepted: $t('form.termsError') }"
          >
            <template #label="context">
              <p
                class="text-s"
                v-html="
                  $t('form.termsLabel', {
                    url: localePath({
                      name: 'policy-privacy',
                    }),
                  })
                "
              />
            </template>
          </FormKit>

          <div class="unlock-download__cta">
            <button
              type="submit"
              class="button-round-1 --dark unlock-download__submit"
            >
              {{ $t('cta.sendUnlockDoenload') }}
            </button>
            <button
              class="link-underline-1 unlock-download__cancel"
              @click="close"
            >
              <span>{{ $t('cta.cancelUnlockDownload') }}</span>
            </button>
          </div>
        </FormKit>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetUnlockDownload',
}
</script>

<script setup>
import { gsap } from 'gsap'

const emit = defineEmits([
  'enable',
  'error',
  'close',
  'animation-update',
  'animation-reverse-complete',
])

const props = defineProps({
  show: Boolean,
  downloadUrl: String,
  endpoint: String,
})

const overlay = ref(null)
const tl = ref(null)

const userData = ref(null)
const showForm = ref(false)

watch(
  () => props.show,
  (show) => {
    if (!tl.value?.isActive()) {
      tl.value = show ? animateIn() : animateOut()
      tl.value.play()
    }
  }
)

const close = (e) => {
  e.preventDefault()
  emit('close')
}

const onSubmit = async (data, node) => {
  try {
    await useFetch(props.endpoint, {
      method: 'post',
      body: {
        fullName: data.fullName,
        role: data.role,
        email: data.email,
      },
    })
  } catch (e) {
    console.log(e)
  }
  emit('close')
  emit('enable')
}

// Animazioni
const animateIn = (params) => {
  const parent = overlay.value
  const background = parent.querySelector(
    '[data-animate="unlock-download-background"]'
  )
  const content = parent.querySelector(
    '[data-animate="unlock-download-content"]'
  )

  const tl = gsap.timeline({
    paused: true,
    onStart: () => {
      showForm.value = true
    },
    onUpdate: () => {
      emit('animation-update', tl.progress())
    },
    onComplete: () => {
      tl.kill()
    },
    ...params,
  })

  tl.set(parent, { autoAlpha: 1 })

  tl.addLabel('start')

  tl.to(
    background,
    {
      opacity: 1,
    },
    'start'
  )
  tl.to(
    content,
    {
      opacity: 1,
    },
    'start'
  )

  return tl
}

const animateOut = (params) => {
  const parent = overlay.value
  const background = parent.querySelector(
    '[data-animate="unlock-download-background"]'
  )
  const content = parent.querySelector(
    '[data-animate="unlock-download-content"]'
  )

  const tl = gsap.timeline({
    paused: true,
    onComplete: () => {
      emit('animation-reverse-complete')
      tl.kill()
      gsap.set([parent, background, content], {
        clearProps: 'all',
      })

      showForm.value = false
    },
    ...params,
  })
  tl.set(document.body, { overflow: 'auto' })
  tl.addLabel('start')

  tl.to(
    content,
    {
      opacity: 0,
    },
    'start'
  )
  tl.to(
    background,
    {
      opacity: 0,
    },
    'start'
  )

  tl.set(parent, { autoAlpha: 0 })

  return tl
}

defineExpose({
  animateIn,
  animateOut,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
